import { Svg } from "../../ws10";

const bannerHeadingText = `Switch to 5G on Germany's best mobile data network`;

const logos = [
  {
    id: 1,
    className: "icon__apple-store",
    src: Svg.AppleStore
  },
  {
    id: 2,
    className: "icon__android-store",
    src: Svg.GoogleStore
  }
];

export const appStoreBannerData = {
  bannerHeadingText: bannerHeadingText,
  logoFiles: logos
};
